import React, {Component} from 'react';


//podczas liczenia dodac film
class Iframeyoutube extends Component {
  
  render () {
  
   
    return [
      
        <div className="iframeprogreswrona" key={1}>
            <h1 style={{color:"white", textAlign:"center"}}>W czasie oczekiwania możesz obejrzeć film</h1>
            <iframe height='315' width='560' className="iframeprogress" frameBorder="0" title="youtewrona" src='https://www.youtube.com/embed/VV87nwAn0Qo' autoPlay allowFullScreen/>
            
        </div>
     
    ]
  }
}



export default Iframeyoutube;